import { z } from 'zod'

export const monthlyDocumentsSchema = z.object({
  no_financial_movement: z.boolean(),
  company: z.object({
    bank_statement_pdf: z.array(z.string()).optional(),
    bank_statement: z.array(z.string()).optional(),
    bank_investment_statement: z.array(z.string()).optional(),
    other: z.array(z.string()).optional(),
  }),
  partners: z.array(
    z.object({
      key: z.string(),
      payslip: z.array(z.string()).optional(),
      monthly_withdraw: z.string().optional(),
    }),
  ),
  observation: z.string().optional(),
})

export type MonthlyDocumentsData = z.infer<typeof monthlyDocumentsSchema>
